module.exports = __webpack_public_path__ + "static/media/EC.cd9f073c.png";